import React, { FC } from 'react';

import { IEnvelopeCheckboxProps as IProps } from '@views/envelopes/types';

import { Checkbox , getCheckboxCheckedValue } from '@infologistics/frontend-libraries';
import cn from 'classnames';
import styles from '../EnvelopeItem.module.scss';

const EnvelopeCheckbox: FC<IProps> = ({ oguid, checkbox, selectedCheckbox }) => {
  return (
    <td className={cn(styles.checkboxCell, checkbox && styles.checkboxCellSelected)}>
      <Checkbox
        checked={getCheckboxCheckedValue(checkbox)}
        name='checkDocument'
        onChange={(e) => selectedCheckbox(e.target.value)}
        value={oguid}
      />
    </td>
  )
}

export default EnvelopeCheckbox
